/** Fecha desde API/SQL sin corrimiento por zona horaria (evita 01-jun → 31-may). */
export const fechaApiToKey = (value) => {
  if (value == null || value === '') return null;
  const match = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : null;
};

/** Formato dd/mm/yyyy desde clave YYYY-MM-DD o valor API. */
export const formatearFechaApi = (value) => {
  const key = fechaApiToKey(value);
  if (!key) return '';
  const [y, m, d] = key.split('-');
  return `${d}/${m}/${y}`;
};
